/*! facett renewal — News（facettからのお知らせ）
 * 4件以上のみ: PC/SPともスライダー（開始揃え＋左右覗き見）
 * 2〜3件は CSS グリッド（JS 不要）
 * Hero 非干渉: data-facett-news のみ
 */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var MQ_PC = '(min-width: 768px)';

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function isPc() {
    return window.matchMedia(MQ_PC).matches;
  }

  function readCssPx(root, prop, fallback) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(' + prop + ')';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || fallback;
  }

  function getCardW(root) {
    return readCssPx(root, '--facett-news-card-w', isPc() ? 712 : 320);
  }

  function getGap(root) {
    return readCssPx(root, '--facett-news-gap', 16);
  }

  function getInsetPx(root) {
    return readCssPx(root, '--facett-news-inset', 24);
  }

  function getContentMax(root) {
    return readCssPx(root, '--facett-news-content', 1440);
  }

  function getContentOffset(root, el) {
    if (!el) return getInsetPx(root);

    var ref = document.querySelector(
      '.facett-news__inner, .facett-material__grid, .facett-category__grid, .facett-recommended__inner'
    );
    if (ref) {
      var delta = Math.round(ref.getBoundingClientRect().left - el.getBoundingClientRect().left);
      if (delta > 0) return delta;
    }

    var vw = window.innerWidth || document.documentElement.clientWidth;
    var inset = getInsetPx(root);
    var content = getContentMax(root);
    return Math.max(inset, Math.round((vw - content) / 2 + inset));
  }

  function destroyNews(root) {
    if (!root) return;
    if (root._facettNewsSwiper && typeof root._facettNewsSwiper.destroy === 'function') {
      try {
        root._facettNewsSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    root._facettNewsSwiper = null;
    root.dataset.facettNewsReady = '';
  }

  function initNews(root) {
    if (!root) return;
    if (root.getAttribute('data-facett-news-mode') !== 'slider') {
      destroyNews(root);
      root.dataset.facettNewsReady = '1';
      return;
    }

    var el = root.querySelector('[data-facett-news-swiper]');
    if (!el || !window.Swiper) return;

    var slides = el.querySelectorAll('.swiper-slide');
    if (slides.length < 2) {
      destroyNews(root);
      root.dataset.facettNewsReady = '1';
      return;
    }

    destroyNews(root);

    var gap = getGap(root);
    var offsetBefore = getContentOffset(root, el);
    var offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(root), 24));

    root._facettNewsSwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: gap,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: offsetAfter,
      watchOverflow: true,
      centerInsufficientSlides: false,
      grabCursor: true,
      a11y: {
        enabled: true,
      },
    });

    root.dataset.facettNewsReady = '1';
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-news]').forEach(function (root) {
      initNews(root);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-facett-news][data-facett-news-mode="slider"]');
    if (!roots.length) return;

    Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
      .then(function () {
        window.requestAnimationFrame(syncAll);
      })
      .catch(function () {
        syncAll();
      });
  }

  var resizeTimer = null;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(boot, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', onResize);
  window.addEventListener('load', boot);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-news]');
    if (root) {
      destroyNews(root);
      boot();
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target && event.target.querySelector('[data-facett-news]');
    if (root) {
      destroyNews(root);
    }
  });
})();
